export default {"src":"/accounts/_next/static/media/Dashboard.795d1c16.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};